import {ConversationType} from '@toolify/server/src/models/mongoose/MessageModel/enum/ConversationType'
import {IConversationTypeInterfacesMap} from '@toolify/server/src/services/MessageService/types/IConversationTypeInterfacesMap'

type AnyConversationPayload = IConversationTypeInterfacesMap[ConversationType]['conversationTypePayload']
type WorkspacePayload = IConversationTypeInterfacesMap[ConversationType.Workspace]['conversationTypePayload']

export function useWorkspaceConversationTypeStrategy() {
  const getConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as WorkspacePayload).conversationId
  }

  const getRelayConversationKey = (payload: AnyConversationPayload): string => {
    return (payload as WorkspacePayload).conversationId
  }

  return {
    getConversationKey,
    getRelayConversationKey,
  }
}
